import React, { useCallback, useMemo, useState } from "react";
import { Box, Button, Dialog, DialogContent, FormControlLabel, Radio, RadioGroup, TextField, Tooltip } from '@mui/material'
import ModAccName from 'components/ModAccName';
import { DialogFooter, DialogHeader } from 'components/dialog/DialogHeader';
import { initDialogData } from "./initData";
import useDialogOpen from "hooks/useDialogOpen";
import { validate } from "utils";
import PaperComponent from "components/PaperComponent";
import { useEffect } from "react";
import CheckboxFormControl from "components/CheckboxFormControl";
import { BoxFC, BoxFR } from "components/BoxCustom";
import { useContext } from "react";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { subcontractApiNm, subcontractColNm } from "constants/subcontractConstant";
import dayjs from "dayjs";
import SwitchFormControl from "components/SwitchFormControl";
import { EmailRounded, DeleteForeverRounded } from "resource/muiImport";
import { alertError, alertSuccess } from "components/Alert";

/**
 * Have to modify ModDte coz driver ModDte and subcontract ModDte are different 
 * So set ModDte to time that open dialog
 */
const modifyModDte = (data) => {
  data.IsHeadBrch = data.BrchNo === 0 ? 1 : 0
  data.ModDte = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS")
  return data
}
const SubcontractDialog = ({ dialogOpen, setDialogOpen, selectedId, onFinish, lastFilter }) => {

  const [dialogData, setDialogData] = useState(initDialogData)

  const { ax } = useContext(GlobalStateContext)

  useDialogOpen(dialogOpen, selectedId, subcontractApiNm.getSubcontract, "ScId", setDialogData, initDialogData, modifyModDte)

  const validation = useMemo(() => ({
    SName: dialogData.SName === '',
    LnkSiteAbbr: dialogData.LnkSiteAbbr?.length > 5,
  }), [dialogData]);

  const dialogDataProp = useCallback((name, required) => ({
    variant: 'outlined',
    size: 'small',
    name: name,
    label: subcontractColNm[name],
    value: dialogData[name] ?? "",
    error: validation[name],
    required: required,
    fullWidth: true,
    onChange: (e) => { setDialogData((oldState) => ({ ...oldState, [name]: e.target.value })) }
  }), [dialogData, validation])

  const insertUpdateSubcontract = useCallback(() => {
    let apiName = selectedId > 0 ? subcontractApiNm.updateSubcontract : subcontractApiNm.insertSubcontract
    ax.post(apiName, { ...dialogData, LnkSiteAbbr: dialogData.LnkSiteAbbr || null, getArgs: lastFilter }).then(value => {
      if (value.data) {
        setDialogOpen(false);
        onFinish(value.data)
      }
    })
  }, [ax, onFinish, selectedId, dialogData, lastFilter, setDialogOpen])

  const deleteSubcontract = useCallback(() => {
    ax.post(subcontractApiNm.deleteSubcontract, { ScId: selectedId, getArgs: lastFilter }).then(value => {
      if (value.data) {
        setDialogOpen(false)
        onFinish(value.data)
      }
    })
  }, [ax, onFinish, selectedId, lastFilter, setDialogOpen])

  const handleUpdateAndSendEmail = useCallback(() => {
    const postData = {
      ...dialogData
      , getArgs: lastFilter
    }
    ax.post(subcontractApiNm.updateAndSendSubcontractEmail, postData).then(value => {
      setDialogOpen(false)
      alertSuccess("บันทึกและส่ง Email เรียบร้อยแล้ว")
    })
  }, [ax, dialogData, lastFilter, setDialogOpen])

  const handleDialogOk = useCallback(() => {
    if (!validate(validation)) return
    if (dialogData.Email !== null && dialogData.Email.length < 4) {
      alertError("Email ต้องมีความยาวมากกว่า 4 ตัวอักษร")
      return
    }
    insertUpdateSubcontract(dialogData)
  }, [validation, dialogData, insertUpdateSubcontract])

  const handleIsHeadBrchChange = useCallback((e) => {

    if (+e.target.value === 1) {

      setDialogData(o => ({ ...o, IsHeadBrch: 1, BrchNo: "0" }))
    } else {

      setDialogData(o => ({ ...o, IsHeadBrch: 0 }))
    }
  }, [])

  useEffect(() => {
    if (dialogOpen === false) {
      setDialogData(initDialogData)
    }
  }, [dialogOpen])
  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='sm' >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="การจัดการรถร่วม"
        onDeleteClick={selectedId > 0 ? () => deleteSubcontract(selectedId) : null}
      />
      <DialogContent>
        {/* <BoxFR mt={2} sx={{ alignItems: "stretch" }}> */}

        <BoxFC sx={{ mt: 1, gap: 1, flex: 3 }}>
          <CheckboxFormControl label="Active" checked={dialogData.IsActv === 1 ? true : false}
            onChange={e => setDialogData(o => ({ ...o, IsActv: e.target.checked ? 1 : 0 }))} />
          <TextField {...dialogDataProp('Name')} />
          <BoxFR width="100%">
            <TextField {...dialogDataProp('SName', true)} />
            <TextField {...dialogDataProp('Abbr')} />
          </BoxFR>
          <TextField {...dialogDataProp('Addr')} multiline rows={3} />
          <BoxFR>
            <TextField {...dialogDataProp('Tel')} />
            <TextField {...dialogDataProp('TaxId')} />
          </BoxFR>
          <BoxFR>
            <RadioGroup row value={dialogData.IsHeadBrch} onChange={handleIsHeadBrchChange}>
              <FormControlLabel value={1} control={<Radio />} label="สำนักงานใหญ่" sx={{ width: 180 }} />
              <FormControlLabel value={0} control={<Radio />} label="สาขาที่" />
              <TextField size="small" {...dialogDataProp('BrchNo')} disabled={dialogData.IsHeadBrch === 1}
                label="เลขที่สาขา" type="number" sx={{ width: 80 }}
                inputProps={{ style: { textAlign: 'center' } }} />
            </RadioGroup>
          </BoxFR>
          <BoxFR>
            <TextField {...dialogDataProp('CtDscp')} />
            <TextField {...dialogDataProp('XpssSupCod')} />
          </BoxFR>
          <BoxFR>
            <TextField {...dialogDataProp('CtMailOpr')} />
            <TextField {...dialogDataProp('CtMailAcc')} />
          </BoxFR>
          <BoxFR>
            <TextField {...dialogDataProp('Rmk')} />
            <TextField {...dialogDataProp('LnkSiteAbbr')} value={dialogData.LnkSiteAbbr ?? ""}
              onChange={(e) => setDialogData(o => ({ ...o, LnkSiteAbbr: e.target.value || null }))}
              helperText={dialogData.LnkSiteAbbr && dialogData.LnkSiteAbbr.length > 3 ? "ตัวย่อต้องไม่เกิน 3 ตัวอักษร" : ""} />
          </BoxFR>

          {dialogData.Email === null ?
            <BoxFR>
              <Button variant="contained" onClick={() => setDialogData(o => ({ ...o, Email: "" }))}>
                กำหนด Email Subcontract
              </Button>
            </BoxFR>
            : <BoxFR>
              <Box width="100%">
                <BoxFR>
                  <TextField {...dialogDataProp('Email')} />
                  <Tooltip title="ลบ Email" sx={{ p: 1, minWidth: 0 }} arrow placement="top">
                    <Button variant="outlined" color="error"
                      onClick={() => setDialogData(o => ({ ...o, Email: null, Pass: "" }))} ><DeleteForeverRounded /></Button>
                  </Tooltip>
                  {dialogData.ScId ?
                    <Tooltip title="บันทึกและส่ง Email ข้อมูล Login" sx={{ p: 1, minWidth: 0 }} arrow placement="top">
                      <Button variant="contained" onClick={handleUpdateAndSendEmail} ><EmailRounded /></Button>
                    </Tooltip> : null
                  }
                </BoxFR>
              </Box>
              <Box width="100%">
                {!dialogData.ScId ?
                  <SwitchFormControl
                    label={dialogData.IsSendEmail === 1 ? "ส่ง Email รหัสผ่าน" : "ไม่ส่ง Email รหัสผ่าน"}
                    checked={dialogData.IsSendEmail === 1 ? true : false}
                    onChange={(e) => setDialogData(o => ({ ...o, IsSendEmail: e.target.checked ? 1 : 0 }))} />
                  : <BoxFR>
                    <TextField {...dialogDataProp('Pass')} type="password" />
                    {/* <Tooltip title="แก้ไขรหัสผ่าน" sx={{p: 1, minWidth: 0}} arrow placement="top">
                    <Button variant="contained" ><CloudSyncRounded /></Button>
                  </Tooltip> */}
                  </BoxFR>
                }

              </Box>
            </BoxFR>
          }
          {
            dialogData.ExpId > 0 && <ModAccName modDte={dialogData.ModDte} modAcc={dialogData.ModAcc} />
          }
        </BoxFC>
        {/* <BoxFC flex={2}  mt={ 2} sx={{gap: 1}}>
            <Typography variant="h6">ข้อมูลการ Login</Typography>
            <TextField {...dialogDataProp('Email')} />
            <TextField {...dialogDataProp('Pass')} type="password"/>
            {!dialogData.ScId ?
              <SwitchFormControl
                label={dialogData.SendEmail === 1 ? "ส่ง Email รหัสผ่าน" : "ไม่ส่ง Email รหัสผ่าน"}
                checked={dialogData.SendEmail === 1 ? true : false}
                onChange={(e) => setDialogData(o => ({ ...o, SendEmail: e.target.checked ? 1 : 0 }))} />
              : null
            }

          </BoxFC> */}
        {/* </BoxFR> */}
      </DialogContent>
      <DialogFooter okText={selectedId > 0 ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(SubcontractDialog)